export default {
  cancelUnpaidCheckout: "Abbrechen",
  changeSelection: "Meine Auswahl ändern",
  packIncludesBoost:
    "Inklusive des {{count}}-Tage-Boosts, der dein Inserat an die Spitze seiner Kategorie setzt.",
  cartHeading: "Prüfe deine Leistungen",
  cartLead: "Alle angezeigten Leistungen werden gemeinsam bezahlt.",
  existingPayment:
    "Eine Zahlung ist noch offen. Prüfe die ursprünglichen Positionen, bevor du erneut bezahlst.",
  resumePackagePayment: "Offene Zahlung prüfen",
  emptyCart: "Keine Leistungen ausgewählt.",
  removeItem: "Entfernen",
  currentCart: "Aktuelle Auswahl",
  reviewCartChanged:
    "Die Auswahl hat sich geändert. Prüfe die Positionen und akzeptiere die Bedingungen erneut.",
  quoteExpiredCart:
    "Dieses Werbeangebot ist abgelaufen. Wähle es erneut bei deiner Anzeige.",
  chooseAgain: "Erneut auswählen",
  contextCreateAd: "Preis für eine neue Anzeige",
  contextMyAds: "Preis über Meine Anzeigen",
  paymentOriginal: "Ursprüngliche Zahlung",
  viewCart: "Ausgewählte Leistungen prüfen",

  continueToCart: "Weiter zur gemeinsamen Kasse",
  bankRateNote:
    "Du zahlst in Euro. Deine Bank rechnet zu ihrem eigenen Wechselkurs um.",
  reverseVat: "Umkehr der Umsatzsteuerschuld · einmalige Zahlung",
  checkout: "Weiter zur Zahlung",
  resumePayment: "Zahlung fortsetzen",
  storeReceipt: "Siehe Store-Beleg",
  title: "Mehr Aufmerksamkeit für dein Inserat",
  lead: "Wähle bezahlte Sichtbarkeit, einen besonderen Look oder beides.",
  boost: "Boost",
  boostDetail: "Rotierende gesponserte Plätze in relevanten Suchen.",
  highlight: "Highlight",
  highlightDetail:
    "Ein dezenter grüner Rahmen hebt dein Inserat hervor. Keine Änderung der Rangfolge.",
  bundle: "Auffallen",
  bundleDetail: "Boost und Highlight für sieben Tage.",
  days: "{{count}} Tage",
  preview: "Vorschau deines Inserats",
  previewNote: "Eine Darstellung des Aussehens, keine garantierte Position.",
  choose: "Option wählen",
  continue: "Promotion prüfen",
  notNow: "Nicht jetzt",
  total: "Gesamt",
  vat: "Inklusive MwSt. · einmalige Zahlung",
  saving: "{{amount}} gegenüber Einzelkauf sparen",
  terms:
    "Die Laufzeit beginnt nach Freigabe und Verfügbarkeit, pausiert bei Nichtverfügbarkeit und endet bei Verkauf oder Rücknahme.",
  consent:
    "Ich akzeptiere die Bedingungen und wünsche den Beginn, sobald mein Inserat geeignet ist.",
  pay: "{{amount}} bezahlen",
  paying: "Wird verarbeitet…",
  error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  retry: "Erneut versuchen",
  unavailable: "Promotions sind für dieses Inserat derzeit nicht verfügbar.",
  history: "Deine Promotions",
  myAdsCta: "Promotions",
  processingPayment: "Zahlung wird verarbeitet",
  activeUntil: "Bis {{date}}",
  endedOn: "Beendet am {{date}}",
  report: "Kampagnenleistung",
  impressions: "Sichtbare Impressionen",
  clicks: "Klicks",
  ctr: "Klickrate",
  noData: "Noch keine Berichtsdaten",
  metricsNote:
    "Erfasste Kampagnenereignisse, keine einzelnen Personen oder zusätzlichen Verkäufe. Mindestens die Hälfte der Karte muss eine Sekunde sichtbar sein.",
  updated: "Aktualisiert: {{date}}",
  start: "Gestartet",
  end: "Endet",
  withdraw: "Promotion zurückziehen",
  withdrawConfirm: "Diese Promotion stoppen?",
  withdrawNote:
    "Die Auslieferung endet sofort. Eine Erstattung wird separat geprüft und ist nicht garantiert.",
  cancel: "Promotion behalten",
  confirm: "Stoppen und Prüfung anfordern",
  back: "Zurück zu meinen Inseraten",
  sponsored: "Gesponsert",
  advertiser: "Bezahlt von {{name}}",
  reason: "Warum dieses Inserat?",
  processing:
    "Wir prüfen die Zahlung beim Server. Das Schließen storniert keine abgeschlossene Zahlung.",
  refresh: "Status aktualisieren",
  paymentConfirmed: "Zahlung bestätigt",
  awaiting_payment: "Zahlung ausstehend",
  awaiting_listing: "Wartet auf dein Inserat",
  active: "Aktiv",
  paused: "Pausiert",
  completed: "Beendet",
  cancelled: "Storniert",
  refund_required: "Prüfung erforderlich",
  refunded: "Erstattet",
  refund_requested: "Erstattung angefordert",
  pending: "Ausstehend",
  paid: "Bezahlt",
  failed: "Fehlgeschlagen",
  payment: "Zahlung",
  noCampaign: "Noch keine Kampagnen. Deine erste Promotion erscheint hier.",
  viewCampaign: "Kampagne ansehen",
  checking: "Verfügbarkeit prüfen…",
  expired: "Dieses Angebot ist abgelaufen. Bitte vor dem Bezahlen erneuern.",
  noGuarantee: "Keine Garantie für Rang, Impressionen oder Verkauf.",
  previewFixture:
    "Lokale Vorschau · fiktives Inserat und Beispieldaten · kein Kauf",
  daily: "Tägliche Aktivität (UTC)",
  date: "Datum",
  selected: "Ausgewählt",
  viewTerms: "Bedingungen lesen",
  termsTitle: "Promotionsbedingungen",
  termsBody:
    "Ein einmaliger bezahlter Werbedienst. Gesponserte Plätze rotieren zwischen relevanten Inseraten; Highlight ändert nur das Aussehen. Die Laufzeit zählt nur bei Eignung. Eine Rücknahme stoppt die Auslieferung und leitet eine manuelle Erstattungsprüfung ein. Gesetzliche Rechte bleiben unberührt.",
  entryTitle: "Hilf den richtigen Käufern, dein Stück zu finden",
  entryBody:
    "Wähle, wie dein Inserat auffällt – in Suchergebnissen und auf der Startseite.",
  entryCta: "Werbemöglichkeiten ansehen",
  editorTitle: "Deine Anzeige bewerben",
  stepChoose: "Auswählen",
  stepReview: "Prüfen",
  stepPayment: "Bezahlen",
  boostBenefit: "Entdeckt werden",
  highlightBenefit: "Blicke auf dich ziehen",
  bundleBenefit: "Beides kombinieren",
  boostBody: "Gesponserte Plätze in passenden Suchergebnissen.",
  highlightBody:
    "Hebe deine Anzeige mit einem grünen Rahmen in Such- und Kategorieergebnissen hervor.",
  bundleBody:
    "Gesponserte Sichtbarkeit und ein grüner Rahmen, zusammen für sieben Tage.",
  chooseDuration: "Laufzeit auswählen",
  previewOriginal: "Deine Anzeige",
  previewPromoted: "Mit deiner Werbung",
  selectionHint: "Wähle eine Option, um fortzufahren",
  reviewTitle: "Deine Werbung auf einen Blick",
  startsWhenReady:
    "Startet, sobald deine Anzeige freigegeben und verfügbar ist",
  pausesWhenNeeded:
    "Pausiert, solange deine Anzeige vorübergehend nicht verfügbar ist",
  trackResults: "Verfolge Einblendungen und Klicks unter Meine Anzeigen",
  close: "Schließen",
  changeOption: "Option ändern",
  fromPrice: "Ab {{amount}}",
  placementPreview: "Gesponserte Ergebnisse",
  appearancePreview: "Suchergebnisse",
  previewEmpty: "So könnte deine Anzeige aussehen",
  oneTime: "Einmalige Zahlung",
  reportListing: "Deine Anzeige",
  viewListing: "Anzeige ansehen",
  reportActivity: "Werbeaktivität",
  reportAllTime: "Über die gesamte Laufzeit",
  reportShown: "Einblendungen",
  reportShownHelp: "Deine beworbene Anzeige war auf dem Bildschirm sichtbar.",
  reportClicksHelp: "Klicks auf deine beworbene Anzeige.",
  reportRateHelp: "Klicks geteilt durch erfasste Einblendungen.",
  reportChecked: "Bericht geprüft am {{date}}",
  reportDaily: "Aktivität pro Tag",
  reportPeriod: "Berichtszeitraum",
  reportFullPeriod: "Gesamter Zeitraum",
  reportLastDays: "Letzte {{count}} Tage mit Aktivität",
  reportRecordedDays:
    "Nur Tage mit erfasster Aktivität werden angezeigt. Die Tage werden nach UTC eingeteilt.",
  reportDataTable: "Tageswerte ansehen",
  reportNoActivity: "Keine Aktivität erfasst",
  reportNoActivityBody:
    "Erfasste Einblendungen und Klicks erscheinen hier. Die Summen oben zeigen, was bisher gemessen wurde.",
  reportBeforeStart: "Dein Bericht beginnt, sobald die Werbung startet.",
  reportPurchase: "Deine Werbung",
  reportIncluded: "In dieser Werbung enthalten",
  reportAmount: "Kaufbetrag",
  reportPurchased: "Zahlung eingegangen",
  reportReference: "Kampagnenreferenz",
  reportScheduledEnd: "Geplantes Ende",
  reportFinishedOn: "Beendet",
  reportSupport: "Support kontaktieren",
  reportRefreshWarning:
    "Wir konnten diesen Bericht nicht aktualisieren. Die zuletzt verfügbaren Informationen bleiben sichtbar.",
  reportPollingStopped:
    "Wir warten noch auf eine Zahlungsaktualisierung. Automatische Prüfungen wurden pausiert. Aktualisiere den Status, um erneut zu prüfen.",
  reportResumeBody:
    "Setze deine bestehende Zahlung fort. Wenn du bereits bezahlt hast, aktualisiere zuerst den Status, bevor du es erneut versuchst.",
  reportPendingBody:
    "Die Zahlung ist noch nicht bestätigt. Prüfe die ursprüngliche Zahlung oder den App Store. Du musst keine weitere Werbung kaufen.",
  reportActiveTitle: "Deine Werbung läuft",
  reportActiveBody:
    "Die gewählten Vorteile sind aktiv, solange deine Anzeige für Käufer verfügbar ist.",
  reportWaitingTitle: "Bereit, sobald deine Anzeige es ist",
  reportWaitingBody:
    "Deine Zahlung ist bestätigt. Die Werbung startet, sobald deine Anzeige freigegeben und verfügbar ist. Deine bezahlte Laufzeit hat noch nicht begonnen.",
  reportPausedTitle: "Deine Werbung ist pausiert",
  reportPausedBody:
    "Deine Anzeige ist vorübergehend nicht verfügbar. Die Werbung wird fortgesetzt, sobald sie wieder verfügbar ist. Die pausierte Zeit wird deiner Laufzeit hinzugefügt.",
  reportHolidayBody:
    "Deine Werbung pausiert, während dein Shop im Urlaub ist. Die bezahlte Zeit bleibt erhalten, bis deine Anzeige wieder verfügbar ist.",
  reportReservedBody:
    "Deine Anzeige ist reserviert. Die Werbung pausiert während der Reservierung; deine bezahlte Zeit bleibt erhalten.",
  reportVerificationBody:
    "Wir prüfen deinen App-Store-Kauf. Die Werbung ist pausiert und deine bezahlte Zeit bleibt erhalten. Du musst nicht erneut kaufen.",
  reportPlatformPauseBody:
    "Wir haben Werbung vorübergehend pausiert. Deine bezahlte Zeit bleibt erhalten. Du musst nichts unternehmen.",
  reportApprovalBody:
    "Deine Anzeige wird geprüft. Die Werbung startet oder wird fortgesetzt, sobald sie freigegeben und verfügbar ist. Die Wartezeit zählt nicht zu deiner Laufzeit.",
  reportFinishedTitle: "Deine Werbung ist beendet",
  reportFinishedBody:
    "Deine gekaufte Laufzeit ist abgelaufen. Der Bericht unten zeigt die während deiner Werbung erfasste Aktivität.",
  reportSoldBody:
    "Dein Artikel wurde verkauft, deshalb wurde die Werbung beendet. Die Aktivität unten zeigt die erfassten Ereignisse, nicht, dass die Werbung den Verkauf verursacht hat.",
  reportWithdrawnBody:
    "Deine Anzeige ist nicht mehr verfügbar, deshalb wurde die Werbung gestoppt.",
  reportStoppedTitle: "Deine Werbung wurde gestoppt",
  reportStoppedBody:
    "Diese Werbung ist nicht mehr aktiv. Deine erfasste Aktivität und Kaufdetails bleiben unten verfügbar.",
  reportReviewTitle: "Deine Werbung muss geprüft werden",
  reportReviewBody:
    "Die Werbung wurde gestoppt, während wir diesen Kauf prüfen. Kontaktiere bei Fragen den Support. Eine Erstattung ist noch nicht bestätigt.",
  reportWithdrawalBody:
    "Dein Antrag ist eingegangen und die Werbung wurde gestoppt. Eine mögliche Erstattung wird gesondert geprüft.",
  reportRefundedTitle: "Zahlung erstattet",
  reportRefundedBody:
    "Eine Erstattung wurde bestätigt. Diese Werbung ist nicht mehr aktiv.",
  reportNotFound: "Wir konnten diese Werbung in deinem Konto nicht finden.",
  reportWithdrawalFailed:
    "Wir konnten deinen Antrag nicht bestätigen. Dieses Fenster bleibt offen, damit du es erneut versuchen kannst. Prüfe bei Unsicherheit den Kampagnenstatus.",
  reportRequestReview: "Prüfung anfordern",
  reportReviewConfirm: "Eine Prüfung dieser Werbung anfordern?",
  reportReviewNote:
    "Die Werbung ist bereits beendet. Wir prüfen deinen Antrag gesondert. Dies ist keine Zusage einer Erstattung.",
  reportConfirmReview: "Antrag senden",
  reportEndedNoActivity:
    "Vor dem Ende dieser Werbung wurde keine Aktivität erfasst.",
  customPromotion: "Deine Werbung",
  border: "Rahmen",
  label: "Label",
  homepage: "Startseitenplatz",
  fullBundle: "Auffallen-Paket",
  selectBundle: "Stand out wählen",
  bundleIncludes: "Boost, Rahmen und Label für 7 Tage",
  bundleSaving: "{{amount}} gegenüber Einzelkäufen sparen",
  bundleRecommendation:
    "Erhalte 7 Tage Boost, Rahmen und Label für {{amount}} — günstiger als diese Auswahl.",
  borderBody: "Ein grüner Rahmen um deine Karte.",
  labelBody: "Dein selbst gewähltes Verkäuferlabel.",
  homepageBody: "Rotierende gesponserte Startseitenkarten.",
  homepageTerms:
    "Ein wechselnder Platz, keine exklusive Position. Keine garantierten Einblendungen oder Verkäufe.",
  homepageHeading: "Mehr entdecken",
  homepageContext: "Auf der Startseite",
  homepagePreviewNote:
    "Deine Karte erscheint in einer wechselnden gesponserten Auswahl. Diese Vorschau verspricht keine feste Position.",
  labelChoose: "Label auswählen",
  labelMustGo: "Muss weg",
  labelMovingSale: "Umzugsverkauf",
  labelInvoice: "Mit Originalrechnung",
  labelCollect: "Abholbereit",
  labelAttestation:
    "Ich bestätige, dass dieses Label für meine Anzeige zutrifft.",
  labelPaidNote:
    "Vom Verkäufer gewählt und bezahlt. Dies ist keine Prüfung durch Whoppah.",
  labelRequired:
    "Wähle ein Label und bestätige seine Richtigkeit, bevor du fortfährst.",
  none: "Keiner",
  addBenefit: "{{benefit}} hinzufügen",
  removeBenefit: "{{benefit}} entfernen",
  selectionUnavailable:
    "Diese Auswahl ist derzeit nicht verfügbar. Ändere deine Auswahl oder prüfe die Verfügbarkeit erneut.",
  effectUnavailable: "Bereits aktiv oder für diese Anzeige nicht verfügbar",
  homepageSoldOut:
    "Die Startseitenplätze sind derzeit belegt. Wähle andere Vorteile oder versuche es später erneut.",
  checkAvailability: "Verfügbarkeit prüfen",
  mixedDurationNote:
    "Jeder Vorteil hat seine eigene Laufzeit. Der Startseitenplatz endet nach 3 Tagen; längere Vorteile laufen weiter.",
  selectedBenefits: "Deine gewählten Vorteile",
  benefitStatus: "Status je Vorteil",
  placementsTitle: "Wo deine Werbung erschien",
  placementSearch: "Suchergebnisse",
  placementCategory: "Kategorieergebnisse",
  placementCard: "Rahmen und Label auf Karten",
  placementHomepage: "Startseite",
  placementLegacyHighlight: "Hervorgehobene Karten",
  placementOther: "Andere Platzierung",
  sharedExposureNote:
    "Eine Karte kann Vorteile aus mehreren Käufen enthalten. Kampagnensummen zählen erfasste Einblendungen, keine eindeutige Reichweite.",
  homepageCapacityWait:
    "Deine Zahlung ist bestätigt. Die Werbung beginnt, sobald ein Startseitenplatz und deine Anzeige verfügbar sind. Deine bezahlte Laufzeit hat noch nicht begonnen.",
  labelSuppressed:
    "Dieses Label wurde zur Prüfung gestoppt. Kontaktiere den Support für Hilfe zu deinem Kauf.",
  newBenefits: "Weitere Werbevorteile hinzufügen",
  previewSearch: "Karte in Such- und Kategorieergebnissen",
  previewHome: "Startseitenkarte",
  benefitEnd: "Geplantes Ende des Vorteils",
  benefitStarts: "Vorteil gestartet",
  historicalBundle: "Boost und Highlight",
  bundleV2Body:
    "Boost, ein grüner Rahmen und dein gewähltes Label, zusammen für 7 Tage.",
  customPromotionBody: "Deine gewählten Werbevorteile.",
  customPromotionBenefit: "Wähle deine Vorteile",
  placementPartial:
    "Für einen Teil der erfassten Aktivität fehlen Angaben zur Platzierung. Diese Aktivität ist weiterhin in deinen Kampagnensummen enthalten.",
  reportSomeActiveBody:
    "Mindestens ein Vorteil läuft. Prüfe unten den jeweiligen Status und die Daten jedes Vorteils.",
  homepageWaitReview:
    "Innerhalb der Wartezeit wurde kein Startseitenplatz frei. Dieser Kauf muss auf Erstattung geprüft werden. Eine Erstattung ist noch nicht bestätigt.",
  chooseBenefits: "Gestalte deine Werbung",
  selectionBenefitsHint: "Wähle eine oder mehrere Optionen",
  termsBodyV2:
    "Dies ist eine einmalig bezahlte Werbeleistung. Plätze auf der Startseite wechseln. Rahmen und Label verändern die Darstellung der Karte; Labels werden vom Verkäufer gewählt und bestätigt, nicht von Whoppah geprüft. Jede Option läuft für ihre gekaufte Dauer, solange das Inserat die Voraussetzungen erfüllt. Ein Kauf mit Startseitenplatz beginnt, wenn ein Platz und das Inserat bereit sind. Ein Widerruf stoppt die Auslieferung und löst eine persönliche Prüfung der Erstattung aus. Deine gesetzlichen Rechte bleiben unberührt.",
  homepageStartFact:
    "Startet, sobald dein Inserat und ein Startseitenplatz verfügbar sind",
  salesEyebrow: "LASS DEIN STÜCK AUFFALLEN",
  salesTitle: "Gutes Design verdient es, gesehen zu werden.",
  salesBody: "Wähle ein Paket oder stelle selbst zusammen.",
  offerBoostBody: "Erreiche Käufer, die nach Stücken wie deinem suchen.",
  offerBundleBody:
    "Mehr Sichtbarkeit. Ein auffälliger Look. Alles in einem Paket.",
  offerHomeTitle: "Stand out + Startseite",
  offerHomeBody:
    "Falle in der Suche auf und wecke Interesse beim Stöbern auf der Startseite.",
  offerBoostCta: "Boost wählen",
  offerHomeCta: "Paket wählen",
  offerAllTogether: "Sichtbarkeit + Stil",
  offerWiderReach: "Suche + Startseite",
  offerSearchReach: "Sichtbarkeit in der Suche",
  offerRecommended: "Unsere Empfehlung",
  offerMixedDuration: "Stand out 7 Tage · Startseite 3 Tage",
  offerSearchBenefit: "Gesponserte Plätze in passenden Suchergebnissen",
  offerStyleBenefit: "Grüner Rahmen + Verkäuferlabel",
  offerResultsBenefit: "Verfolge Impressionen und Klicks unter Meine Inserate",
  offerBundleBenefit: "Boost + Rahmen + Label",
  offerHomeBenefit: "Rotierender Startseitenplatz",
  offerSelected: "Ausgewählt",
  offerCustomize: "Einzelne Optionen wählen",
  offerMakeYours: "Deine Vorschau",
  offerPreviewBody: "Prüfe deine Auswahl vor dem Bezahlen.",
  completionOptional:
    "Werbung ist optional. Du kannst dich auch später unter Meine Inserate entscheiden.",
  individualOptionsBody: "Einzeln wählen oder kombinieren.",
  individualLink: "Einzeloptionen ansehen",
  standOutTitle: "Lass dein Inserat auffallen",
  standOutLead:
    "Wähle eine oder mehrere Optionen. Startet, sobald dein Inserat live und verfügbar ist.",
  packDetail: "7 Tage Boost, Rahmen und Label zusammen.",
  bestValue: "Preisvorteil",
  percentOff: "{{percent}}% Rabatt",
  orSeparately: "oder einzeln wählen",
  boostPickerDetail:
    "Dein Inserat kommt wieder an die Spitze seiner Kategorie. Startet, sobald dein Inserat online ist.",
  boostRunning:
    "Für dieses Inserat läuft bereits ein Boost. Du kannst einen neuen Boost hinzufügen, sobald er abgelaufen ist.",
  framePickerDetail:
    "Ein grüner Rahmen um dein Inserat in den Suchergebnissen, für 7 Tage.",
  labelMustGoTitle: "Label „Muss weg“",
  previousPaymentProcessing:
    "Deine vorherige Zahlung wird noch verarbeitet. Versuche es in einer Minute erneut.",
  labelPickerDetail: "Ein kurzes Label an deinem Inserat für 7 Tage.",
  homepagePickerDetail:
    "Ein rotierender gesponserter Platz auf der Startseite für 3 Tage.",
  searchPreviewTitle: "So sieht dein Inserat in den Suchergebnissen aus",
  searchPreviewLead:
    "Dein Inserat mit grauen Platzhaltern für die Inserate daneben.",
  promotedTab: "Beworben",
  boostSummary: "Boost für {{count}} Tage",
  labelSummary: "Label „{{text}}“",
  nothingSelected: "Nichts ausgewählt",
  continueWithPrice: "Weiter zur Zahlung · {{price}}",
  goToMyAds: "Zu meinen Inseraten",
  pricingContextChanged:
    "Der Rabatt für neue Inserate ist nicht mehr verfügbar. Die Preise wurden aktualisiert.",
} as const;
